import { useEffect } from 'react';
import { useHistory, useRouteMatch } from 'react-router';

const SchedulePage = () => {
  const history = useHistory();
  const match = useRouteMatch();

  useEffect(() => {
    if (match.isExact) {
      history.replace(`/app/schedules/kanban`);
    }
  }, [match]);

  return null;
};

export default SchedulePage;
